module.exports = __webpack_public_path__ + "static/media/Leppert Schlosserei.12f53a9b.png";